import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";
import Select from 'react-select'
import { useParams, useNavigate } from "react-router-dom";

import { MDBInput, MDBSwitch, MDBTextArea, MDBBtn } from "mdb-react-ui-kit";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import de from 'react-phone-input-2/lang/de.json'

import {
    ageRanges,
    ageRangeToBirthday,
    backendPathEmployees,
    backendPathPartners,
    birthdayToAgeRange,
    germanLevels,
    ratings
} from "../Constants";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


const regionNames = new Intl.DisplayNames(
    ['de'], { type: 'region' }
);


function EditEmployee() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [partners, setPartners] = useState([]);

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [birthday, setBirthday] = useState();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [license, setLicense] = useState(0);
    const [smoker, setSmoker] = useState(0);
    const [germanLevel, setGermanLevel] = useState(-1);
    const [actualGermanLevel, setActualGermanLevel] = useState(-1);
    const [rating, setRating] = useState(-1);
    const [ratingAnnotation, setRatingAnnotation] = useState("");
    const [recommendation, setRecommendation] = useState(0);
    const [taskAnnotation, setTaskAnnotation] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [inactive, setInactive] = useState(0);
    const [partnerID, setPartnerID] = useState(0);
    const [partnerLabel, setPartnerLabel] = useState("");
    const [nationality, setNationality] = useState("");

    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const getEmployee = () => {
        Axios.get(`${backendPathEmployees}employee.php?id=${id}`).then((response) => {
            const employee = response.data[0];
            console.log(employee);
            setName(employee.FirstName);
            setSurname(employee.LastName);
            setBirthday(employee.Birthday);
            setPhoneNumber(employee.PhoneNumber);
            setLicense(employee.License);
            setSmoker(employee.Smoker);
            setGermanLevel(employee.GermanLevel);
            setActualGermanLevel(employee.ActualGermanLevel);
            setRating(employee.Rating);
            setRatingAnnotation(employee.RatingAnnotation);
            setRecommendation(employee.Recommendation);
            setTaskAnnotation(employee.TaskAnnotation);
            setEscalation(employee.Escalations);
            setAnnotation(employee.Annotation);
            setInactive(employee.Inactive);
            setPartnerID(employee.PartnerId);
            setPartnerLabel(employee.PartnerName);
        });
    };

    const getPartners = () => {
        Axios.get(backendPathPartners+"partners.php").then((response) => {
            setPartners(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.Name, value: val.PartnerID };
            }));
        });
    };

    const checkCompleteness = () => {
        return !(!name || !surname || !birthday || !phoneNumber || germanLevel < 0);

    };

    const updateEmployee = () => {
        setSubmitted(true);

        if (!checkCompleteness()) {
            return;
        }

        Axios.get(backendPathEmployees+"update-employee.php", {
            params: {
                name: name,
                surname: surname,
                birthday: birthday,
                phoneNumber: phoneNumber,
                license: license,
                smoker: smoker,
                germanLevel: germanLevel,
                actualGermanLevel: actualGermanLevel,
                rating: rating,
                ratingAnnotation: ratingAnnotation,
                recommendation: recommendation,
                taskAnnotation: taskAnnotation,
                escalation: escalation,
                annotation: annotation,
                inactive: inactive,
                partnerId: partnerID,
                nationality: nationality,
                id: id,
            }
        }).then(() => {
            console.log(id, name, surname, birthday, phoneNumber, license, smoker, germanLevel, actualGermanLevel, rating, ratingAnnotation, recommendation, taskAnnotation, escalation, annotation);
            navigate("/employee/" + id);
        });
        
    };

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getEmployee();
        getPartners();
    }, [id]);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className="main">
                <div className="header">
                    <h2>Betreuungskraft bearbeiten</h2>
                </div>
                
                <div className='input-form'>
                    <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text' value={name} onChange={(event) => {
                        setName(event.target.value);
                    }} />
                    {(submitted && !name)?
                        <p className="validation-label">Vorname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input" label='Nachname' id='form2' type='text' value={surname} onChange={(event) => {
                        setSurname(event.target.value);
                    }} />
                    {(submitted && !surname)?
                        <p className="validation-label">Nachname darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Partner</p>
                    <Select className="input" id="select1" placeholder={'Auswählen...'} options={partners} value={partnerID ? {label: partnerLabel, value: partnerID} : null} onChange={(event) => {
                        console.log(event);
                        setPartnerID(event.value);
                        setPartnerLabel(event.label);
                    }} />

                    <div className="input">
                        <MDBSwitch label={!inactive ? "Status aktiv" : "Status inaktiv"} checked={!inactive} onChange={(event) => setInactive(s => (s+1)%2)}/>
                    </div>

                    <p className="input-label">Alter</p>
                    <Select className="input" id="select2" placeholder={'Auswählen...'} options={ageRanges} value={ageRanges[birthdayToAgeRange(birthday)]} onChange={(event) => {
                        setBirthday(ageRangeToBirthday(event.value));
                    }} />
                    {(submitted && !birthday)?
                        <p className="validation-label">Alter darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Telefon</p>
                    <PhoneInput
                        className="input"
                        id="select3"
                        localization={de}
                        value={phoneNumber}
                        enableSearch={true}
                        searchPlaceholder={'Suchen'}
                        onChange={(value, c, e, formattedValue) => {
                            setPhoneNumber(formattedValue);
                            setNationality(regionNames.of(c.countryCode));
                        }}
                    />
                    {(submitted && !phoneNumber) ?
                        <p className="validation-label">Telefonnummer darf nicht leer sein.</p> : null
                    }

                    <div className="input"><MDBSwitch id='licenseSwitch' label='Führerschein vorhanden' checked={license} onChange={(event) => {
                        setLicense(s => (s+1)%2);
                    }} /></div>

                    <div className="input"><MDBSwitch id='smokerSwitch' label='Raucher/in' checked={smoker} onChange={(event) => {
                        setSmoker(s => (s+1)%2);
                    }}/></div>

                    <p className="input-label">angegebene Deutschkenntnisse</p>
                    <Select className="input" id="select4" placeholder={'Auswählen...'} options={germanLevels} value={germanLevels[germanLevel]} onChange={(event) => {
                        setGermanLevel(event.value);
                    }} />
                    {(submitted && germanLevel < 0)?
                        <p className="validation-label">Deutschkenntnisse darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">tatsächliche Deutschkenntnisse</p>
                    <Select className="input" id="select5" placeholder={'Auswählen...'} options={germanLevels} value={actualGermanLevel >= 0? germanLevels[actualGermanLevel] : ""} onChange={(event) => {
                        setActualGermanLevel(event.value);
                    }} />

                    <p className="input-label">Bewertung</p>
                    <Select className="input" id="select6" placeholder={'Auswählen...'} options={ratings} value={rating >= 0? ratings[rating] : ""} onChange={(event) => {
                        setRating(event.value);
                    }} />

                    <MDBTextArea className="input" label='Bemerkung zu der Bewertung' id='textAreaExample' rows={4} value={ratingAnnotation} onChange={(event) => {
                        setRatingAnnotation(event.target.value);
                    }} />

                    <div className="input"><MDBSwitch id='recommendedSwitch' label='für erneute Einsätze empfohlen' checked={recommendation} onChange={(event) => {
                        setRecommendation(s => (s+1)%2);
                    }} /></div>
                    
                    <MDBTextArea className="input" label='Bemerkung für erneute Einsätze' id='textAreaExample' rows={4} value={taskAnnotation} onChange={(event) => {
                        setTaskAnnotation(event.target.value);
                    }} />

                    <MDBTextArea className="input" label='Eskalationen' id='textAreaExample' rows={4} value={escalation} onChange={(event) => {
                        setEscalation(event.target.value);
                    }} />

                    <MDBTextArea className="input" label='Notizen' id='textAreaExample' rows={4} value={annotation} onChange={(event) => {
                        setAnnotation(event.target.value);
                    }} />
                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={updateEmployee}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default EditEmployee;